// extracted by mini-css-extract-plugin
export default {"action":"CreateChat_action__33baV","groupImage":"CreateChat_groupImage__ZwluI","none":"CreateChat_none__Uo4p1"};